module.exports = __webpack_public_path__ + "static/media/bryan_czar.d574e610.jpg";